import DeletePopOver from 'Components/DeletePopOver'
import ErrorComponent from 'Components/ErrorComponent'
import Message from 'Components/Message'
import TableLoading from 'Components/TableLoading'
import { calculateDuration, dateTimeFormat, formattooltip, getDefaultVesselValue, handleDeleteoffHire } from 'GenericForms/Helper'
import Layout from 'HorizontalMenu/Menu'
import Navbar from 'HorizontalMenu/Navbar'
import { RootState } from 'index'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { Col, Container, Label, Row } from 'reactstrap'
import { customStyle } from 'shared/CommonCSS'
import { OnboardingStatus } from 'shared/constants'
import { queryKeyes } from 'shared/queryKeys'
import { getVesselsAction, setOnboardedVessels, setVesselID } from 'Store/Generic/ReportingSlice'
import { Get } from 'VesselMaster/vesselMaster.hooks'
import OffhierForm from './OffhireForm'
import ToolTip from 'Components/ToolTip'
import PopUp from 'Components/PopUp'
import { userVessels } from 'utils/auth/authUtils'

const OffhireByVessel = () => {
    const [deleateId, setDeleateId] = useState<number>(null)
    const [deleatePopOver, setDeleatePopOver] = useState<boolean>(false);
    const [Record, setRecord] = useState<any>(null);
    const [showModal, setShowModal] = useState<boolean>(false)
    const [hoverId, setHoverId] = useState<string>(null);
    const dispatch = useDispatch();
    const { Vessels, VesselID, onboardedVessels } = useSelector(
        (state: RootState) => state.Reporting
    );
    const vessel = Vessels.find((rec: any) => rec.id === VesselID);
    const handleVesselSelectionChanges = (e: any) => {
        dispatch(setVesselID(e ? e?.id : null));
    };
    let applicableVessels = userVessels();
    const { data, isLoading, isError } = useQuery(
        [queryKeyes.offHire.OffHirePeriodByVessel.key, VesselID],
        async () => {
            return await Get(queryKeyes.offHire.OffHirePeriodByVessel.url(VesselID), VesselID);
        },
        {
            enabled: true,
            staleTime: Infinity
        }
    )
    const offhireData = data?.data || [];
    /** useEffect */
    /** Populate Vessels array */
    useEffect(() => {
        dispatch(getVesselsAction("vessel_master" as string));
    }, [dispatch]);

    /** Effect 2: Set onboarded vessels when Vessels data is available */
    useEffect(() => {
        if (Array.isArray(Vessels)) {
            const onboardedVessels = Vessels.filter(
                (vessel) => vessel.onboarding_status === OnboardingStatus.ONBOARDED
            );
            dispatch(setOnboardedVessels(onboardedVessels));
        }
    }, [Vessels, dispatch]);
    /** useEffect end */
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>

            <div className="page-content">
                <Container fluid>
                    <Row className="mb-2">
                        <Col sm={4}>
                            <Label className="mb-0">Select vessel</Label>
                            <Select
                                options={
                                    onboardedVessels.filter((item: any) => item.display === true &&
                                        applicableVessels?.includes(item?.id)) as any[]
                                }
                                getOptionLabel={(o: any) =>
                                    `${o.vessel_name_type_name}`
                                }
                                isClearable={true}
                                getOptionValue={(option: any) => option.id}
                                onChange={(e: any) => handleVesselSelectionChanges(e)}
                                menuPortalTarget={document.body}
                                styles={customStyle}
                                defaultValue={getDefaultVesselValue(
                                    VesselID,
                                    vessel,
                                    onboardedVessels,
                                    applicableVessels
                                )}
                            />
                        </Col>
                        <Col sm={8} className="pt-3 text-end">
                            <div className="d-inline-block">
                                <h3 className="m-0">Off Hire Management</h3>
                            </div>
                        </Col>
                    </Row>
                    {isLoading && <TableLoading />}
                    {isError && <ErrorComponent message="Unable to load required data!" />}
                    {!isLoading && !isError && offhireData && (
                        <div className="table-responsive">
                            <table className="table mt-2 align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th className="p-2 text-center">#</th>
                                        <th className="p-2">Start Date & Time</th>
                                        <th className="p-2">End Date & Time</th>
                                        <th className="p-2 text-center">Duration</th>
                                        <th className="p-2 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {offhireData.length > 0 ? (
                                        offhireData.map((record: any, index: number) => (
                                            <tr key={record.id}>
                                                <td className="p-2 text-center">{index + 1}</td>
                                                <td className="p-2">
                                                    {dateTimeFormat(record.start_date_time, false, false, true)}
                                                </td>
                                                <td className="p-2">
                                                    {dateTimeFormat(record.end_date_time, false, false, true)}
                                                </td>
                                                <td className="p-2 text-center">
                                                    {calculateDuration(record.start_date_time, record.end_date_time)}
                                                </td>
                                                <td className="p-2 text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-soft-primary waves-effect waves-light me-1"
                                                        id={`Edit_Offhire_${record.id}`}
                                                        onMouseEnter={() => setHoverId(`Edit_Offhire_${record.id}`)}
                                                        onMouseLeave={() => setHoverId("")}
                                                        onClick={() => {
                                                            setRecord(record);
                                                            setShowModal(true);
                                                        }}
                                                    >
                                                        <i className="bx bx-edit-alt font-size-16 align-middle"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-soft-danger waves-effect waves-light"
                                                        id={`Delete_Offhire_${record.id}`}
                                                        onMouseEnter={() => setHoverId(`Delete_Offhire_${record.id}`)}
                                                        onMouseLeave={() => setHoverId("")}
                                                        onClick={() => {
                                                            setDeleateId(record.id);
                                                            setDeleatePopOver(true);
                                                            setHoverId(null);
                                                        }}
                                                    >
                                                        <i className="dripicons-trash font-size-16 align-middle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={5} className="text-center p-3 text-muted">
                                                <Message message={'No data available'} type={'danger'} width='480px' />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {hoverId && document.getElementById(hoverId) !== null && (
                        <ToolTip
                            target={hoverId}
                            message={formattooltip(hoverId)}
                            isOpen={!!hoverId}
                        />
                    )}
                    {showModal && (
                        <PopUp
                            title="Add Off hire period"
                            state={showModal}
                            setState={setShowModal}
                            size="lg"
                            body={<OffhierForm setState={setShowModal} values={Record} />}
                        />
                    )}
                    {deleatePopOver &&
                        <DeletePopOver
                            target={`Delete_Offhire_${deleateId}`}
                            onClick={() => {
                                handleDeleteoffHire(deleateId);
                                setDeleatePopOver(false);
                            }}
                            message={`Are you sure you want to delete ${deleateId}`}
                            state={deleatePopOver}
                            setState={setDeleatePopOver}
                        />
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

export default OffhireByVessel